'use strict';

module Patersons {

    export class IncomeReport extends AbstractReport {
        transactionTypeCategories: TransactionTypeCategory[];
        grandTotal: IncomeReportLineItem;
    }

    export class TransactionTypeCategory {
        name: string;
        subCategories: TransactionTypeSubCategory[];
        subtotal: IncomeReportLineItem;
    }

    export class TransactionTypeSubCategory {
        name: string;
        lineItems: IncomeReportLineItem[];
        subtotal: IncomeReportLineItem;
    }

    export class IncomeReportLineItem {
        payDate: Date;
        exDate: Date;
        code: string;
        description: string;
        amount: number;
        frankingCredits: number;
        withholdingTax: number;
        gst: number;
        transType: string;
        subTransType: string;
    }

    export class IncomeReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/incomeReport.component.html';
        controller: any = IncomeReportController;
        bindings: any = {
            report: '<',
            title: '@'
        };
    }

    export class IncomeReportController extends AbstractReportController {
        report: IncomeReport;
    }

}

